import { render, staticRenderFns } from "./DefaultHeading.vue?vue&type=template&id=50e5fa18"
import script from "./DefaultHeading.vue?vue&type=script&lang=js"
export * from "./DefaultHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports